// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as Utils$OrcaPaymentPage from "../../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "../RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../../Utilities/JotaiAtoms.bs.js";
import * as DropdownField$OrcaPaymentPage from "../DropdownField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../../Utilities/DynamicFieldsUtils.bs.js";

function StateDropdownField(props) {
  var fieldConfig = props.fieldConfig;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(fieldConfig, localeString);
  var validate = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(fieldConfig, localeString);
  var countryName = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.userCountry);
  var countryIso = Utils$OrcaPaymentPage.getCountryCode(countryName).isoAlpha2;
  var stateDisplayNames = Utils$OrcaPaymentPage.getStateNames({
        value: countryName,
        errorString: ""
      });
  var stateOptions = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(stateDisplayNames);
  var hasStates = stateOptions.length > 0;
  var stateField = ReactFinalForm.useField(fieldConfig.confirmRequestWritePath, {
        validate: validate
      });
  var storedCode = Core__Option.getOr(stateField.input.value, "");
  var storedDisplayName = Utils$OrcaPaymentPage.getStateNameFromCode(storedCode, countryIso);
  var isStoredCodeValidForCountry = stateDisplayNames.includes(storedDisplayName);
  var firstStateName = Core__Option.getOr(stateDisplayNames[0], "");
  var effectiveDisplayName = isStoredCodeValidForCountry ? storedDisplayName : firstStateName;
  var effectiveCode = Utils$OrcaPaymentPage.getStateCodeFromStateName(effectiveDisplayName, countryIso);
  React.useEffect((function () {
          if (hasStates && storedCode !== effectiveCode) {
            stateField.input.onChange(effectiveCode);
          }
          
        }), [
        hasStates,
        storedCode,
        effectiveCode
      ]);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: hasStates,
              children: React.createElement(DropdownField$OrcaPaymentPage.make, {
                    appearance: match.config.appearance,
                    value: effectiveDisplayName,
                    setValue: (function (fn) {
                        var selectedDisplayName = fn(effectiveDisplayName);
                        var stateCode = Utils$OrcaPaymentPage.getStateCodeFromStateName(selectedDisplayName, countryIso);
                        stateField.input.onChange(stateCode);
                      }),
                    fieldName: match$1.label,
                    options: stateOptions,
                    disabled: false
                  })
            });
}

var make = StateDropdownField;

export {
  make ,
}
/* jotai Not a pure module */
